<template>
    <li class="mpn-item-box">
        <a class="mpn-item" :href="productURL" :title="product.descriptionRU">
            <div class="responsive-box">

                <div class="art" :style="imgStyle">
                    Артикул<br><span class="mpn">{{product.mpn}}</span>
                </div>

                <div class="logo">
                    <img :src="product.serieslogo" alt="Офисная мебель LAS">
                </div>

            </div>
            <span class="mpname">
                {{product.nameRU}} <br>
            </span>
            <span class="price">
                <!-- Цена{{product.no_nds ? ' (без НДС)' : ''}}:&nbsp; -->
                Цена{{product.no_nds ? '' : ''}}:&nbsp;
                <span> 
                    <!-- <span v-html="product.currency"></span> -->
                    {{product.currency}}
                    {{parseFloat(product.price)}}
                </span>
            </span>
        </a>
    </li>
</template>

<script>

export default {
  name: 'ProductItem',
  props: ['product'],
  methods: {

    requestFinish: function() {
      this.$parent.$emit('finish', this.product);
    } //requestFinish

  }, //methods

  computed: {

    productURL: function() {
      return 'http://www.las.ru' + this.product.url;
    }, //productURL

    imgStyle: function() {
      return 'background: url(' + this.product.svg + ')' +
             'no-repeat center center; background-size: ' + this.product.scale + '% auto;';
    }, //imgStyle

    strNDS: function() {
      // return this.product.no_nds ? " (без НДС)" : "";
      return this.product.no_nds ? " " : "";
    }, //strNDS

    priceReduced: function() {
      return this.product.price * 0.9;
    } //priceReduced

  } //computed
} //default
</script>

<style scoped>
    .art {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background-size: 100% auto; /* фон под размеры блока */
        font-size: 1.1em;
        text-align: right;
    }
    .mpn { 
        font-size: 1.2em;
        font-weight: bold; 
    }
    .mpname {
        font-size: 1.1em;
    }
    .price {
        padding: 0.4em;
        display: inline-block;
    }
    .price span {
        font-size: 1.4em;
        font-weight: bold;
    }

    .product-item {
    border-bottom: 1px dotted gray;
    padding-bottom: 10px;
    }

    .product-item:last-child {
    border-bottom: none;
    }

    .product-name {
    font-weight: 600;
    color: #337ab7;
    font-size: 1.3em;
    line-height: 100%;
    }

    .product-info {
    font-size: 1.7em;
    }

    .label-item {
    font-weight: 600;
    color: #667B82;
    }
</style>



// WEBPACK FOOTER //
// src/ProductListItem.vue